import baseConfig from '@config/baseConfig';

const phaserConfig = baseConfig();

export const config = {
  width: phaserConfig.width,
  height: phaserConfig.height,
};

export const gameState = {
  /** index into GAME_ROUNDS (0..8). Tutorial is its own scene. */
  roundIndex: 0,
  /** number of correctly evaluated game rounds (0..9). */
  score: 0,
  /** mistakes across the whole session (just informational). */
  mistakes: 0,
};

export function resetGameState() {
  gameState.roundIndex = 0;
  gameState.score = 0;
  gameState.mistakes = 0;
}
